import * as React from 'react';
import { Row, Col } from 'reactstrap';
import Page from './Page';



export default class AdminEntityManagement extends React.PureComponent {
    public render() {
        return (
            <Page>

            </Page>
        );
    }
}